import React, { Component } from "react";
import { DatePicker, Select, Spin, message, Radio, Space } from "antd";
import Bridge from "../../../../utils/Bridge";
import dayjs from "dayjs";
import moment from "moment";
import {
  LE_STUDY_DEMOGRAPHICS_CONTENT,
  RESEARCH_TYPE,
  US_STATES,
} from "../../../../utils/consts";

import englishJson from "../../../../utils/language/leStudy/english.json";
import spanishJson from "../../../../utils/language/leStudy/spanish.json";
import noLanguageJson from "../../../../utils/language/leStudy/noLanguage.json";
import { logEvent } from "../../../../utils/analytics";

const { Option } = Select;

export default class PersonalInfo extends Component {
  constructor(props) {
    super(props);
    this.state = {
      first_name: "",
      last_name: "",
      middle_name: "",
      date_of_birth: null,
      loading: false,
      current_age: "",
      caregiver_status: "",
      date_of_diagnosis: null,
      age_at_diagnosis: "",
      place_of_birth_country: "",
      place_of_birth_city_province: "",
      place_of_birth_state: "",
      place_of_birth_other_country: "",
    };
  }
  componentDidMount() {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
    this.get_demographic_details();
  }
  get_demographic_details = () => {
    this.setState({ loading: true });
    let params = "?eals_id=" + localStorage.getItem("ap_eals_id");
    Bridge.demographics.le_study
      .get(params)
      .then((response) => {
        if (response.status == "1") {
          if (response.data.length > 0) {
            let stateUpdates = {};
            for (let item of response.data) {
              if (item.parent_field === "First Name") {
                stateUpdates.first_name = item.value;
              }
              if (item.parent_field === "Middle Name") {
                stateUpdates.middle_name = item.value;
              }
              if (item.parent_field === "Last Name") {
                stateUpdates.last_name = item.value;
              }
              if (item.parent_field === "Date of Birth") {
                stateUpdates.date_of_birth = item.value
                  ? dayjs(item.value)
                  : null;
              }
              if (item.parent_field === "Current Age") {
                stateUpdates.current_age = item.value;
              }
              if (item.parent_field === "Caregiver Status") {
                stateUpdates.caregiver_status = item.value;
              }
              if (item.parent_field === "Date of Diagnosis") {
                stateUpdates.date_of_diagnosis = item.value
                  ? dayjs(item.value, "MM/YYYY")
                  : null;
              }
              if (item.parent_field === "Age at Diagnosis") {
                stateUpdates.age_at_diagnosis = item.value;
              }
              if (item.parent_field === "Place of Birth Country") {
                stateUpdates.place_of_birth_country = item.value;
              }
              if (item.parent_field === "Place of Birth City/Province") {
                stateUpdates.place_of_birth_city_province = item.value;
              }
              if (item.parent_field === "Place of Birth State") {
                stateUpdates.place_of_birth_state = item.value;
              }
              if (item.parent_field === "Place of Birth Other Country") {
                stateUpdates.place_of_birth_other_country = item.value;
              }
            }
            // Calculate Age at Diagnosis if both Date of Birth and Date of Diagnosis exist
            if (stateUpdates.date_of_birth && stateUpdates.date_of_diagnosis) {
              const calculatedAgeAtDiagnosis = dayjs(
                stateUpdates.date_of_diagnosis
              ).diff(dayjs(stateUpdates.date_of_birth), "year");
              stateUpdates.age_at_diagnosis = Math.abs(
                calculatedAgeAtDiagnosis
              ).toString();
            }
            this.setState({ ...stateUpdates, loading: false });
          } else {
            this.setState({ loading: false });
          }
        } else {
          this.setState({ loading: false });
        }
      })
      .catch((error) => {
        this.setState({ loading: false });
      });
  };
  onChange = (date, dateString) => {
    let dob = dayjs(date).format("YYYY-MM-DD");
    const calculatedAge = moment().diff(moment(dob), "years");
    this.setState(
      {
        date_of_birth: date,
        current_age: calculatedAge,
      },
      () => {
        // Calculate Age at Diagnosis if Date of Diagnosis exists
        if (this.state.date_of_diagnosis && date) {
          const calculatedAgeAtDiagnosis = dayjs(
            this.state.date_of_diagnosis
          ).diff(dayjs(date), "year");
          this.setState({
            age_at_diagnosis: Math.abs(calculatedAgeAtDiagnosis).toString(),
          });
        }
      }
    );
  };
  validateName = (field, label, formData) => {
    // Check if the input contains only alphabetic characters
    // if (!/^[A-Za-z]+$/.test(field)) {
    //   // message.warning(`${label} can only contain alphabetic characters.`);
    //   return `${label} can only contain alphabetic characters.`;
    // }
    // Check if the length of the input is within a specific range
    if (field.length <= 2 || field.length > 30) {
      // message.warning(`${label} must be between 2 and 30 characters long.`);
      return formData.page.demographicQuestions.messages.validation.firstNameLength;
    }
    return 1;
  };
  // step 1 - goToNextStep: true = Save & Next (validate + navigate), false = Save for later (no validation, stay)
  save_details = (goToNextStep = true) => {
    const formData =
      RESEARCH_TYPE === "LE Study"
        ? this.props.language === "English"
          ? englishJson
          : this.props.language === "Spanish"
            ? spanishJson
            : englishJson
        : englishJson;

    // Validation only for Save & Next
    if (goToNextStep) {
      if (!this.state.first_name) {
        message.warning(formData.page.demographicQuestions.messages.validation.firstNameRequired);
        return;
      }
      const validateFirstName = this.validateName(
        this.state.first_name,
        "First Name",
        formData
      );
      if (validateFirstName != 1) {
        message.warning(validateFirstName);
        return;
      }
      if (!this.state.last_name) {
        message.warning(formData.page.demographicQuestions.messages.validation.lastNameRequired);
        return;
      }
      const validateLastName = this.validateName(
        this.state.last_name,
        "Last Name",
        formData
      );
      if (validateLastName != 1) {
        message.warning(validateLastName);
        return;
      }
      if (!this.state.date_of_birth) {
        message.warning(formData.page.demographicQuestions.messages.validation.dateOfBirthRequired);
        return;
      }
      let last18YearsStartDate = moment().subtract(18, "years");
      last18YearsStartDate = moment(last18YearsStartDate).format("YYYY-MM-DD");
      let dob2 = dayjs(this.state.date_of_birth).format("YYYY-MM-DD");
      if (dob2 > last18YearsStartDate) {
        message.warning(
          formData.page.demographicQuestions.messages.validation.minAge18Years
        );
        return;
      }

      if (!this.state.current_age) {
        message.warning(formData.page.demographicQuestions.messages.validation.currentAgeRequired);
        return;
      }
      if (!this.state.place_of_birth_country) {
        message.warning(formData.page.demographicQuestions.messages.validation.placeOfBirthRequired);
        return;
      }
      if (this.state.place_of_birth_country == "US") {
        if (!this.state.place_of_birth_city_province) {
          message.warning(formData.page.demographicQuestions.messages.validation.cityProvinceRequired);
          return;
        }
        if (!this.state.place_of_birth_state) {
          message.warning(formData.page.demographicQuestions.messages.validation.stateRequired);
          return;
        }
      }
      if (this.state.place_of_birth_country == "Other") {
        if (!this.state.place_of_birth_city_province) {
          message.warning(formData.page.demographicQuestions.messages.validation.cityProvinceRequired);
          return;
        }
        if (!this.state.place_of_birth_state) {
          message.warning(formData.page.demographicQuestions.messages.validation.stateRequired);
          return;
        }
        if (!this.state.place_of_birth_other_country) {
          message.warning(formData.page.demographicQuestions.messages.validation.countryRequired);
          return;
        }
      }
      if (!this.state.caregiver_status) {
        message.warning(formData.page.demographicQuestions.messages.validation.caregiverStatusRequired);
        return;
      }
    }

    let dob = this.state.date_of_birth ? dayjs(this.state.date_of_birth).format("MM/DD/YYYY") : "";
    const saveForLater = !goToNextStep;

    let missingFields = [];
    if (!this.state.first_name) missingFields.push("First Name");
    if (!this.state.last_name) missingFields.push("Last Name");
    if (!this.state.date_of_birth) missingFields.push("Date of Birth");
    if (!this.state.current_age) missingFields.push("Current Age");
    if (!this.state.place_of_birth_country) missingFields.push("Place of Birth Country");
    else if (this.state.place_of_birth_country === "US") {
      if (!this.state.place_of_birth_city_province) missingFields.push("City/Province");
      if (!this.state.place_of_birth_state) missingFields.push("State");
    } else if (this.state.place_of_birth_country === "Other") {
      if (!this.state.place_of_birth_city_province) missingFields.push("City/Province");
      if (!this.state.place_of_birth_state) missingFields.push("State");
      if (!this.state.place_of_birth_other_country) missingFields.push("Country");
    }
    if (!this.state.caregiver_status) missingFields.push("Caregiver Status");

    const isPersonalInfoComplete = missingFields.length === 0 ? 1 : 0;

    let questions = [
      ...(saveForLater
        ? [
          {
            parent_field: "Save",
            field: "Save for later date",
            value: dayjs().format("MM/DD/YYYY HH:mm"),
          },
        ]
        : []),
      {
        parent_field: "Personal Information Save Type",
        field: "Personal Information Save Type",
        value: saveForLater ? "Save for Later" : "Save Personal Info",
      },
      {
        parent_field: "Is Personal Information Fields Submitted",
        field: "Is Personal Information Fields Submitted",
        value: isPersonalInfoComplete,
      },
      {
        parent_field: "Personal Information Missing Fields",
        field: "Personal Information Missing Fields",
        value: JSON.stringify(missingFields),
      },
      {
        parent_field: "First Name",
        field: "First Name",
        value: this.state.first_name,
      },
      {
        parent_field: "Middle Name",
        field: "Middle Name",
        value: this.state.middle_name,
      },
      {
        parent_field: "Last Name",
        field: "Last Name",
        value: this.state.last_name,
      },
      {
        parent_field: "Date of Birth",
        field: "Date of Birth",
        value: this.state.date_of_birth ? dob : "",
      },
      {
        parent_field: "Current Age",
        field: "Current Age",
        value: this.state.current_age,
      },
      {
        parent_field: "Place of Birth Country",
        field: "Place of Birth Country",
        value: this.state.place_of_birth_country,
      },
      {
        parent_field: "Place of Birth City/Province",
        field: "Place of Birth City/Province",
        value: this.state.place_of_birth_city_province,
      },
      {
        parent_field: "Place of Birth State",
        field: "Place of Birth State",
        value: this.state.place_of_birth_state,
      },
      {
        parent_field: "Place of Birth Other Country",
        field: "Place of Birth Other Country",
        value: this.state.place_of_birth_other_country,
      },
      {
        parent_field: "Caregiver Status",
        field: "Caregiver Status",
        value: this.state.caregiver_status,
        subId:
          LE_STUDY_DEMOGRAPHICS_CONTENT.find(
            (item) => item.field == "caregiverStatus"
          )?.content.find(
            (item) => item.subtitle == this.state.caregiver_status
          )?.subId || "",
      },
    ];
    // Add Age at Diagnosis if it has been calculated
    if (this.state.age_at_diagnosis) {
      questions.push({
        parent_field: "Age at Diagnosis",
        field: "Age at Diagnosis",
        value: this.state.age_at_diagnosis,
      });
    }
    let params = {
      eals_id: localStorage.getItem("ap_eals_id"),
      data: JSON.stringify(questions),
      step: "1",
      action_type: this.props.is_update == true ? "update" : "insert",
    };
    this.setState({ loading: true });
    Bridge.demographics.le_study
      .save(params)
      .then((response) => {
        this.setState({ loading: false });
        if (response.data.status == "1") {
          logEvent("demographics_saved", { section: "personal_info" });
          const formData =
            RESEARCH_TYPE === "LE Study"
              ? this.props.language === "English"
                ? englishJson
                : this.props.language === "Spanish"
                  ? spanishJson
                  : englishJson
              : englishJson;
          message.success(
            formData.page.demographicQuestions.messages
              .demographicsDataAddedSuccessfully
          );
          this.setState(
            {
              loading: false,
            },
            () => {
              if (this.props.is_update == true) {
                setTimeout(() => {
                  window.location.assign("/about-me");
                }, 3000);
              } else {
                this.props.set_active_step(2);
              }
            }
          );
        } else {
          message.error(response.data.message);
          this.setState({ loading: false });
        }
      })
      .catch((error) => {
        message.warning("Please try again!!", error);
        this.setState({ loading: false });
      });
  };
  render() {
    const disabledDate = (current) => {
      // Disable all dates after today
      return current && current > moment().subtract(18, "years");
    };    
    const formData =
      RESEARCH_TYPE === "LE Study"
        ? this.props.language === "English"
          ? englishJson
          : this.props.language === "Spanish"
            ? spanishJson
            : noLanguageJson
        : englishJson;
    return (
      <div>
        <div className="header">
          <h3>
            {
              formData.page.demographicQuestions.fields.personalDetails
                .innerTitle
            }
          </h3>
          <div className="white-block"></div>
        </div>
        {this.props.language ? (
          <Spin spinning={this.state.loading}>
            <div className="form-fields">
              <p className="manadatory-note">
                <strong className="text-danger">Note:</strong>{" "}
                {formData.page.demographicQuestions.allFieldsMandatory}
              </p>
              <div className="form-group">
                <label className="mb-2 input-heading">
                  {
                    formData.page.demographicQuestions.fields.personalDetails
                      .firstName
                  }
                </label>
                <br />
                <input
                  type="text"
                  name="first_name"
                  value={this.state.first_name}
                  onChange={(e) => this.setState({ first_name: e.target.value })}
                  maxLength={30}
                />
              </div>
              <div className="form-group">
                <label className="mb-2 input-heading">
                  {
                    formData.page.demographicQuestions.fields.personalDetails
                      .middleName
                  }{" "}
                  {formData.page.demographicQuestions.fields.personalDetails.optional}
                </label>
                <br />
                <input
                  type="text"
                  name="middle_name"
                  value={this.state.middle_name}
                  maxLength={30}
                  onChange={(e) => this.setState({ middle_name: e.target.value })}
                />
              </div>
              <div className="form-group">
                <label className="mb-2 input-heading">
                  {
                    formData.page.demographicQuestions.fields.personalDetails
                      .lastName
                  }
                </label>
                <br />
                <input
                  type="text"
                  name="last_name"
                  value={this.state.last_name}
                  onChange={(e) => this.setState({ last_name: e.target.value })}
                  maxLength={30}
                />
              </div>
              <div className="form-group">
                <label className="mb-2 input-heading">
                  {
                    formData.page.demographicQuestions.fields.personalDetails
                      .dateOfBirth
                  }{" "}
                  (MM/DD/YYYY)
                </label>
                <br />
                <DatePicker
                  onChange={this.onChange}
                  format={"MM/DD/YYYY"}
                  disabledDate={disabledDate}
                  value={this.state.date_of_birth}
                  placeholder={formData.page.demographicQuestions.fields.personalDetails.placeholders.selectDate}
                  style={{
                    width: "100%",
                    height: 55,
                    maxWidth: 500,
                  }}
                />
              </div>
              <div className="form-group">
                <label className="mb-2 input-heading">
                  {
                    formData.page.demographicQuestions.fields.personalDetails
                      .currentAge
                  }
                </label>
                <br />
                <input
                  type="number"
                  name="current_age"
                  value={this.state.current_age}
                  onChange={(e) => this.setState({ current_age: e.target.value })}
                  maxLength={3}
                />
              </div>
              <div className="form-group">
                <label className="mb-2 input-heading">
                  {
                    formData.page.demographicQuestions.fields.personalDetails
                      .placeOfBirth
                  }
                </label>
                <br />
                <Select
                  onChange={(value) =>
                    this.setState({
                      place_of_birth_country: value,
                      place_of_birth_city_province: "",
                      place_of_birth_state: "",
                      place_of_birth_other_country: "",
                    })
                  }
                  value={this.state.place_of_birth_country}
                  className="col-lg-12"
                  style={{ height: 55, maxWidth: 500 }}
                  placeholder={formData.page.demographicQuestions.fields.personalDetails.placeholders.selectCountry}
                >
                  <Option value="">{formData.page.demographicQuestions.fields.personalDetails.placeholders.select}</Option>
                  <Option value="US">US</Option>
                  <Option value="Other">Other</Option>
                </Select>
              </div>
              {this.state.place_of_birth_country == "US" && (
                <>
                  <div className="form-group">
                    <label className="mb-2 input-heading">
                      {
                        formData.page.demographicQuestions.fields.personalDetails
                          .cityProvince
                      }
                    </label>
                    <br />
                    <input
                      type="text"
                      name="place_of_birth_city_province"
                      value={this.state.place_of_birth_city_province}
                      onChange={(e) =>
                        this.setState({
                          place_of_birth_city_province: e.target.value,
                        })
                      }
                      placeholder={formData.page.demographicQuestions.fields.personalDetails.placeholders.cityProvince}
                      style={{ maxWidth: 500 }}
                    />
                  </div>
                  <div className="form-group">
                    <label className="mb-2 input-heading">
                      {
                        formData.page.demographicQuestions.fields.personalDetails
                          .state
                      }
                    </label>
                    <br />
                    <Select
                      onChange={(value) =>
                        this.setState({
                          place_of_birth_state: value,
                        })
                      }
                      value={this.state.place_of_birth_state}
                      className="col-lg-12"
                      style={{ height: 55, maxWidth: 500 }}
                      placeholder={formData.page.demographicQuestions.fields.personalDetails.placeholders.selectState}
                    >
                      <Option value="">{formData.page.demographicQuestions.fields.personalDetails.placeholders.select}</Option>
                      {US_STATES.map((state, index) => (
                        <Option key={index} value={state}>
                          {state}
                        </Option>
                      ))}
                    </Select>
                  </div>
                </>
              )}
              {this.state.place_of_birth_country == "Other" && (
                <>
                  <div className="form-group">
                    <label className="mb-2 input-heading">
                      {
                        formData.page.demographicQuestions.fields.personalDetails
                          .cityProvince
                      }
                    </label>
                    <br />
                    <input
                      type="text"
                      name="place_of_birth_city_province"
                      value={this.state.place_of_birth_city_province}
                      onChange={(e) =>
                        this.setState({
                          place_of_birth_city_province: e.target.value,
                        })
                      }
                      placeholder={
                        formData.page.demographicQuestions.fields.personalDetails
                          .cityProvince
                      }
                      style={{ maxWidth: 500 }}
                    />
                  </div>
                  <div className="form-group">
                    <label className="mb-2 input-heading">
                      {
                        formData.page.demographicQuestions.fields.personalDetails
                          .state
                      }
                    </label>
                    <br />
                    <input
                      type="text"
                      name="place_of_birth_state"
                      value={this.state.place_of_birth_state}
                      onChange={(e) =>
                        this.setState({
                          place_of_birth_state: e.target.value,
                        })
                      }
                      placeholder={
                        formData.page.demographicQuestions.fields.personalDetails
                          .state
                      }
                      style={{ maxWidth: 500 }}
                    />
                  </div>
                  <div className="form-group">
                    <label className="mb-2 input-heading">
                      {
                        formData.page.demographicQuestions.fields.personalDetails
                          .country
                      }
                    </label>
                    <br />
                    <input
                      type="text"
                      name="place_of_birth_other_country"
                      value={this.state.place_of_birth_other_country}
                      onChange={(e) =>
                        this.setState({
                          place_of_birth_other_country: e.target.value,
                        })
                      }
                      placeholder={
                        formData.page.demographicQuestions.fields.personalDetails
                          .country
                      }
                      style={{ maxWidth: 500 }}
                    />
                  </div>
                </>
              )}
              <div className="form-group">
                <label className="mb-2 input-heading">
                  {
                    formData.page.demographicQuestions.fields.personalDetails
                      .careGiverStatus
                  }
                </label>
                <br />
                <Select
                  onChange={(value) =>
                    this.setState({
                      caregiver_status: value,
                    })
                  }
                  value={this.state.caregiver_status}
                  className="col-lg-12"
                  style={{ height: 55, maxWidth: 500 }}
                >
                  {formData.page.demographicQuestions.fields.personalDetails.careGiverStatusOptions.map(
                    (option) => (
                      <Option key={option.value} value={option.value}>
                        {option.label}
                      </Option>
                    )
                  )}
                </Select>
              </div>
              {this.props.is_update == true ? (
                <div className="d-flex mt-5">
                  <button
                    className="submit-button ml-2"
                    style={{
                      marginLeft: 0,
                      padding: "9px 15px 10px 20px",
                    }}
                    onClick={() => this.save_details(false)}
                  >
                    {formData.page.demographicQuestions.button.saveForLater}
                  </button>
                  <button
                    className="submit-button ml-2"
                    style={{
                      marginLeft: 17,
                      padding: "9px 15px 10px 20px",
                    }}
                    onClick={() => this.save_details(true)}
                  >
                    {formData.page.demographicQuestions.button.save}{" "}
                    <box-icon
                      name="chevron-right"
                      color="#fff"
                      style={{ position: "relative", top: 1 }}
                    ></box-icon>
                  </button>
                </div>
              ) : (
                <div className="d-flex mt-5">
                  <button
                    style={{
                      padding: "9px 28px 10px 21px",
                      background: "#b3b3b3",
                      cursor: "auto",
                    }}
                    className="submit-button"
                  >
                    <box-icon
                      name="chevron-left"
                      color="#fff"
                      style={{ position: "relative", top: 1 }}
                    ></box-icon>
                    {formData.page.demographicQuestions.button.previous}
                  </button>
                  <button
                    className="submit-button ml-2"
                    style={{
                      marginLeft: 17,
                      padding: "9px 15px 10px 20px",
                    }}
                    onClick={() => this.save_details(false)}
                  >
                    {formData.page.demographicQuestions.button.saveForLater}
                  </button>
                  <button
                    className="submit-button ml-2"
                    style={{
                      marginLeft: 17,
                      padding: "9px 15px 10px 20px",
                    }}
                    onClick={() => this.save_details(true)}
                  >
                    {formData.page.demographicQuestions.button.savenext}{" "}
                    <box-icon
                      name="chevron-right"
                      color="#fff"
                      style={{ position: "relative", top: 1 }}
                    ></box-icon>
                  </button>
                </div>
              )}
            </div>
          </Spin>
        ) : (
          <div className="form-fields">
            <div style={{ textAlign: "center", padding: "50px" }}>
              <Spin size="large" />
            </div>
            <div className="white-block"></div>
          </div>
        )}
      </div>
    );
  }
}
